import React from "react";
import manWithBooks from "../asset/student.png";
import { useNavigate } from "react-router-dom";
import logo from "../asset/logowhite.png";
const StartLearning = () => {
  const navigate = useNavigate(); // ✅ Fix here

  return (
    <div className="flex min-h-screen">
      {/* Left Side - Image */}
      <div className="w-1/2 bg-[#083B75] flex items-start justify-start rounded">
            <div className="w-full flex justify-center mt-6 mb-4">
        <img src={logo} alt="logo" className="w-40 sm:w-48 md:w-56 lg:w-64 object-contain" />
      </div>
        <img
          src={manWithBooks}
          alt="Man with books on head"
          className="max-h-[80%] object-contain"
        />
      </div>

      {/* Right Side - Text and Button */}
      <div className="w-1/2 font-inter bg-white flex flex-col items-start p-12">
        <h1 className="text-[72px] font-bold text-[#083B75] leading-tight mb-8">
          START YOUR
          <br />
          LEARNING
          <br />
          JOURNEY
        </h1>
        <button
          onClick={() => navigate('/student-panel/student-dashboard')} // ✅ This now works
          className="bg-[#1C3664] text-white text-lg font-semibold px-6 py-3 rounded-md shadow-md hover:bg-blue-600 transition flex items-center gap-2"
        >
          Start your Learning
          <span className="text-2xl">→</span>
        </button>
      </div>
    </div>
  );
};

export default StartLearning;
